import me from '../../../../../../libraries/fed-resources/resources/me';
import emailConnect from '../../../../../../libraries/fed-resources/resources/email-connect';
import { setLoginStatus } from '../../../../../../auth/authSlice';
import { getInitialSpotIdBeNetwork } from '../../../../../../spot-selector/spotSelectorUtils';

import ErrorNotifier from 'app/scripts/services/error-notifier';
import { getNetwork, setJWTToken, setSpotId } from 'app/scripts/services/app-state';
import { syncCurrentUserToRedux, syncSpotsToRedux } from 'state/helpers/syncHelpers';
import { dispatch } from 'state/store';

export default async function (context, { email, password }, done) {
  dispatch(setLoginStatus('loading'));
  try {
    setSpotId(undefined);
    await emailConnect.multiEmailLogin(email, password);
    let { headers, body: loginData } = await me.loginRegistered();
    let { body: spotsData } = await me.getMyMultiSpots();
    const hasPermissions = Object.values(spotsData || {}).find(spots => Array.isArray(spots) && spots.length > 0);

    if (!hasPermissions) {
      dispatch(setLoginStatus('error'));
      return;
    }

    syncCurrentUserToRedux(loginData);
    const spots = syncSpotsToRedux(spotsData);
    const initialSpotId = getInitialSpotIdBeNetwork(spots, getNetwork().id);

    if (!initialSpotId) {
      dispatch(setLoginStatus('error'));
      return;
    }

    const accessToken = headers['x-access-token'];

    setJWTToken(accessToken);
    window.localStorage?.setItem('SPOTIM_ACCESS_TOKEN', accessToken);

    dispatch(setLoginStatus('success'));
    done();
  } catch (reason) {
    console.error(reason);
    ErrorNotifier.notifyError(reason);
    dispatch(setLoginStatus('error'));
    done();
  }
}
